import { userContext } from '../userManager';
import { getStartAndEndDateByTag } from '../../utils/dates';

export const apiInstrumentsGet = (instrumentId) =>
  userContext.apiCall({
    url: `/instruments/${instrumentId}`,
    method: 'GET',
  });

export const apiInstrumentsListGet = ({ onlyEnabled = true, type, types, orderBy, limit }) =>
  userContext.apiCall({
    url: `/instruments`,
    qs: { onlyEnabled, type, orderBy, limit, types },
    method: 'GET',
  });

export const apiInstrumentsPatch = (instrumentId, instrument) =>
  userContext.apiCall({
    url: `/instruments/${instrumentId}`,
    method: 'PATCH',
    body: instrument,
  });

export const apiInstrumentsDetails = (instrumentIds) =>
  userContext.apiCall({
    url: `/instruments/details`,
    method: 'POST',
    body: { instrumentIds },
  });

export const apiInstrumentsPerformanceGet = (
  instrumentId,
  { benchmarkId, yearsTag, compareIds, startDate }
) => {
  let newStartDate = startDate;
  if (yearsTag) {
    newStartDate = getStartAndEndDateByTag(yearsTag).startDate;
  }

  return userContext.apiCall({
    url: `/instruments/${instrumentId}/performances`,
    qs: {
      compareInstrumentIds: compareIds ?? '',
      benchmarkId,
      startDate: newStartDate,
    },
  });
};

export const apiInstrumentsKpisGet = (instrumentId, { yearsTag, startDate, endDate }) => {
  let newStartDate = startDate;
  let newEndDate = endDate;
  if (yearsTag) {
    const dates = getStartAndEndDateByTag(yearsTag);
    newStartDate = dates.startDate;
    newEndDate = dates.endDate;
  }

  return userContext.apiCall({
    url: `/instruments/${instrumentId}/kpis`,
    qs: {
      startDate: newStartDate,
      endDate: newEndDate,
    },
  });
};

/* EFTs */

export const apiEtfsListGet = ({
  broadAssetClass,
  benchmarkIndex,
  peerCategory,
  onlyRecommended,
}) =>
  userContext.apiCall({
    url: '/etfs',
    method: 'GET',
    qs: {
      broadAssetClass,
      benchmarkIndex,
      peerCategoryId: peerCategory?.id,
      onlyRecommended,
    },
  });

export const apiEtfsBroadAssetClassesGet = () =>
  userContext.apiCall({
    url: '/etfs/broad-asset-classes',
    method: 'GET',
  });

export const apiEtfsBenchmarkIndicesGet = () =>
  userContext.apiCall({
    url: '/etfs/benchmark-indices',
    method: 'GET',
  });

/* Funds */

export const apiFundsListGet = ({
  broadAssetClass,
  benchmarkIndex,
  peerCategory,
  onlyRecommended,
}) =>
  userContext.apiCall({
    url: '/funds',
    method: 'GET',
    qs: {
      broadAssetClass,
      benchmarkIndex,
      peerCategoryId: peerCategory?.id,
      onlyRecommended,
    },
  });

export const apiFundsBroadAssetClassesGet = () =>
  userContext.apiCall({
    url: '/funds/broad-asset-classes',
    method: 'GET',
  });

export const apiFundsBenchmarkIndicesGet = () =>
  userContext.apiCall({
    url: '/funds/benchmark-indices',
    method: 'GET',
  });
